import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, CardTitle } from 'reactstrap';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css';
import {LoginField} from '../../../views/controls/_FieldValication'
import { logout } from '../../../views/client/actions'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validateActiveAcc } from '../../../lib/validation'

// Import actions
import resendConfirmAccRequest from './actions';

class ResendConfirmAcc extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    resendConfirmAccRequest: PropTypes.func,
    logout: PropTypes.func,
    resendConfirmAcc: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
 
  constructor(props) {
    super(props);
  }

  submit = (values) => {
    this.props.resendConfirmAccRequest(values, this.props.history)
  }

  backToLogin = () => {
    this.props.logout();
    this.props.history.push('/login');
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      resendConfirmAcc: {
        requesting,
        successful,
        messages,
        errors,
      },
    } = this.props
    
    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href="https://vsphar.win">
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg="6" md="8" xs="10">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <BlockUi tag="div" blocking={requesting}>
                    <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                    <CardTitle>Yêu cầu gửi lại mã xác nhận tài khoản</CardTitle>
                    <Field iconText="@" type="email" name="email" placeholder="Địa chỉ email của bạn" component={LoginField} className="form-control"/>
                    <Row>
                      <Col md="12">
                        {!requesting && !!errors.length && (
                          <Errors errors={errors} />
                        )}
                        {!requesting && !!messages.length && (
                          <Messages messages={messages} />
                        )}  
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="6">
                        <Button disabled={!this.props.valid} color="primary" className="px-4" action="submit">Gửi lại mã</Button>
                      </Col>
                      <Col xs="12" md="6">
                        <Button color="link" onClick={this.backToLogin} className="px-0 text-gray">Quay lại trang đăng nhập</Button>
                      </Col>
                    </Row>
                    </form>
                    </BlockUi>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  resendConfirmAcc: state.resendConfirmAcc,
})

const connected = connect(mapStateToProps, { resendConfirmAccRequest, logout })(ResendConfirmAcc)

const formed = reduxForm({
  form: 'resendConfirmAcc',
  validate: validateActiveAcc,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/ResendConfirmAcc/ResendConfirmAcc.js